import { render, staticRenderFns } from "./unionClassCourse.vue?vue&type=template&id=7ab5ac05&scoped=true&"
import script from "./unionClassCourse.vue?vue&type=script&lang=js&"
export * from "./unionClassCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5ac05",
  null
  
)

export default component.exports